import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import LocationSearch from "./LocationSearch";
import { useSelector } from 'react-redux';
import heart from "../images/heart.png";
import redheart from "../images/redheart.png";
import WeatherSearch from "./WeatherSearch";

const PhotoDetails = ({ favoriteList, handleAddFavorite }) => {

    const [photos, setPhotos] = useState([])
    const [isLoaded, setIsLoaded] = useState(null)
    const [favorite, setFavorite] = useState(false)
    const user = useSelector((state) => state.user.user)
    const {id} = useParams()

    const handleSetFavorite = (newFavorite) => {
      setFavorite(favorite => !favorite)
      handleAddFavorite(newFavorite)
  }

    useEffect(() => {
        fetch(`https://fotoset.herokuapp.com/photos/${id}`)
        .then((r) => r.json())
        .then(photos => {
                const initialFav = favoriteList.find((fav) => {
                  return fav.photo.id === parseInt(id)
              })
                if (initialFav) {
                  setFavorite(true)
              } else {
                  setFavorite(false)
              }
            setPhotos(photos)
            setIsLoaded(true)
        })
      }, [id, favoriteList])

    if (!isLoaded) return <h2 className="loading">Loading...</h2>;

    const {image, camera, aperture, shutter_speed, iso, lens, location, time, category, weather, notes, owner} = photos

    const handleFavoriteClick = () => {
      fetch("https://fotoset.herokuapp.com/favorites", {
          method: "POST",
          headers: {
              "Content-Type": "application/json"
          },
          body: JSON.stringify( { user_id: user.id, photo_id: id } )
      })
      .then(r => r.json())
      .then((newFavorite) => {
          handleSetFavorite(newFavorite)})
  }

    return(
  <>
    <div className="photo-details">
      <div className="details-container">
        <div className="full-left-side">
          <div className="details-card">
            <img src={image} className="owner-photo" alt="owner-img" />
          </div>
            <br/>
            {favorite ?<img src={redheart} className="heart" alt="redheart"/>
            :
            <img src={heart} className="heart" onClick={handleFavoriteClick} alt="heart"/>}
            <br/>
            <h4>Camera: {camera}</h4>
            <h5>Aperture: {aperture}</h5>
            <h5>Shutter Speed: {shutter_speed}</h5>
            <h5>ISO: {iso}</h5>
            <h5>Lens: {lens}</h5>
            <h5>Location: {location}</h5>
            <h5>Time: {time}</h5>
            <h5>Category: {category}</h5>
            <h5>Weather: {weather}</h5>
            <h5>Notes: {notes}</h5>
        </div>
        <div className="full-right-side">
            <h2>Photographer's Info:</h2>
            <hr/>
            <h3>Photographer Name: {owner.full_name}</h3>
            <h3>Email: {owner.email}</h3>
            <h3>Phone: {owner.phone}</h3>
            <h4>City: {owner.city}</h4>
            <br/>
            <h4>Bio: {owner.bio}</h4>
            <br/>
            <hr/>
        </div>
      </div>
    </div>
    <div className="map">
      <LocationSearch/>
    </div>
    <div className="weather">
      <WeatherSearch />
    </div>
  </>
    )
}

export default PhotoDetails;